import * as React from "react";
import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Paper from "@mui/material/Paper";
import config from "../../config";
import Icon from "../../shared/Icon";
import { AHI_IMAGES } from "./constants";
import "./ahi.scss";
import { postOpsLog } from "../../serviceCalls";
import { launchAhiSystemFn } from "./AhiScore";
const InfoDialog = ({ ahiDescriptions, showText = true }) => {
  /** ************************************************* SETUP *************************************************** */

  const [show, setShow] = React.useState(false);
  const [currentStatus, setCurrentStatus] = React.useState(ahiDescriptions[0]);

  /** ************************************************* HOOKS *************************************************** */

  /** *********************************************** FUNCTIONS ************************************************* */

  const showAhiModal = (e) => {
    e.preventDefault();
    setShow(true);
  };

  const hideAndLaunchAhiSystem = (e) => {
    launchAhiSystemFn({ url: config.ahi.launchUrl, postOpsLog })(e);
    setShow(false);
  };

  /** ************************************************* RENDER ************************************************** */
  return (
    <>
      <AhiLink onClick={(e) => showAhiModal(e)}>
        {showText && <AhiText>AHI-PI</AhiText>}
        <Icon symbol="info" />
      </AhiLink>

      {show && (
        <Dialog
          open={show}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <Header>
            <StyledTitle>AHI-PI Additional Information</StyledTitle>
            <IconWrapper>
              <StyledIcon
                className="close"
                symbol="x"
                onClick={() => setShow(false)}
              />
            </IconWrapper>
          </Header>

          <StyledDialogContent>
            <TabsWrapper>
              <TabList>
                {ahiDescriptions.map((status) => {
                  return (
                    <TabWrapper
                      key={status.id}
                      onClick={() => setCurrentStatus(status)}
                      selectedStatus={status.id === currentStatus.id}
                    >
                      <StyledImg src={AHI_IMAGES[status.id]} />
                      <TabText>{status.status}</TabText>
                    </TabWrapper>
                  );
                })}
              </TabList>
              <TabContentWrapper>
                <TabContentTitle>{currentStatus.status}</TabContentTitle>
                <TabContentText
                  className="ahi-description"
                  dangerouslySetInnerHTML={{
                    __html: currentStatus.description,
                  }}
                />
              </TabContentWrapper>
            </TabsWrapper>
          </StyledDialogContent>
          {config.ahi.launchUrl && (
            <Footer>
              <LaunchButton onClick={hideAndLaunchAhiSystem}>
                Launch AHI System
              </LaunchButton>
            </Footer>
          )}
        </Dialog>
      )}
    </>
  );
};

export default InfoDialog;

const PaperComponent = (props) => {
  return <Paper {...props} />;
};

/** ************************************************* STYLES ************************************************** */

const AhiLink = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 4px;
  color: #7d7d7d;
`;

const AhiText = styled.div`
  font-size: 12px;
  padding: 0 2px;
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 24px;
  width: 700px;
  height: 400px;
`;

const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Footer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 24px;
`;

const StyledTitle = styled.div`
  padding: 12px;
  display: flex;
  font-size: 24px;
  font-weight: 700;
`;

const IconWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
`;

const StyledImg = styled.img`
  height: 25px;
  width: 25px;
`;

const StyledIcon = styled(Icon)`
  height: 25px !important;
  width: 25px !important;
`;

const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const TabList = styled.div`
  display: flex;
  border-bottom: 1px solid #e7e7e7;
`;

const TabWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  padding: 8px;
  white-space: nowrap;
  border-bottom: ${({ selectedStatus }) =>
    selectedStatus ? "3px solid #1cacdd" : "revert"};
`;

const TabText = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.4px;
  padding-left: 8px;
`;

const TabContentWrapper = styled.div`
  padding-top: 12px;
  display: flex;
  flex-direction: column;
`;

const TabContentTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  align-self: center;
`;

const TabContentText = styled.div``;

const LaunchButton = styled.button`
  background: #1cacdd;
  color: #fff;
  border: 0;
  padding: 0.7em 1em;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
`;
